import { Component, OnInit, OnDestroy } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { HeaderTitleService } from 'src/app/modules/general/services/title.service';

@Component({
  selector: 'app-booking-advanced-products',
  templateUrl: './booking-advanced-products.component.html',
  styleUrls: ['./booking-advanced-products.component.css']
})
export class BookingAdvancedProductsComponent implements OnInit, OnDestroy {

  constructor(
    protected bookingStepService: BookingStepService,
    protected bookingOrderService: BookingOrderService,
    private headerTitleService: HeaderTitleService,
  ) { }

  ngOnInit(): void {
    this.headerTitleService.isVisibleTitle = true;
  }

  ngOnDestroy(): void {
    this.headerTitleService.isVisibleTitle = false;
  }

  onBackwardClick(): void {
    this.bookingStepService.back();
  }

  onForwardClick(): void {
    this.bookingStepService.forward();
  }
}
